import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import { register } from 'register-service-worker'
import { CreateElement, VNode } from 'vue/types/umd'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h: CreateElement): VNode => {
    return h(App)
  }
}).$mount('#app')

if (process.env.NODE_ENV === 'production') {
  register(`${process.env.BASE_URL}sw.js`, {
    ready () {
      console.log('App is being served from cache by a service worker. \nFor more details, visit https://goo.gl/AFskqB')
    },
    registered () {
      console.log('Service worker has been registered.')
    },
    cached () {
      console.log('Content has been cached for offline use.')
    },
    updatefound () {
      console.log('New content is downloading.')
    },
    updated () {
      console.log('New content is available; please refresh.')
    },
    offline () {
      console.log('No internet connection found. App is running in offline mode.')
    },
    error (error) {
      console.error('Error during service worker registration:', error)
    }
  })
}
